import { render, staticRenderFns } from "./Chapter5_1.vue?vue&type=template&id=bd37dfc0&scoped=true&"
import script from "./Chapter5_1.vue?vue&type=script&lang=js&"
export * from "./Chapter5_1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd37dfc0",
  null
  
)

export default component.exports